import Locale from '../Entities/Locale.js';
import LocaleString from '../Entities/LocaleString.js';

function LocaleStringsService (apiInstance)
{
  const api = apiInstance;

  this.fetchForLocale = (locale) => {
    return api.request('GET', null, '/locales/' + locale + '/strings', {})
      .then(function (response) {
        const data = response.data.data;
        const locale = new Locale(data.locale);
        const strings = data.strings.map(function (data) {
          return new LocaleString(data);
        });

        return {
          locale: locale,
          strings: strings
        }
      })
      .catch(function (response) {
        return [];
      });
  }

  this.bulk = (locale, strings, mode) => { 
    let data = [];

    strings.forEach(function (locale) {
      if (locale.props.isDirty) {
        if (mode === 'translate') {
          if (locale.props.isCreated) {
            if (locale.props.value !== null && locale.props.value !== "") {
              data.push({ key: locale.props.key, action: 'update', value: locale.props.value });
            } else {
              data.push({ key: locale.props.key, action: 'delete' });
            }
          } else {
            if (locale.props.value !== null && locale.props.value !== "") {
              data.push({ key: locale.props.key, action: 'translate', value: locale.props.value });
            }
          }
        } else if (mode === 'validate') {
          switch (locale.props.state) {
            case 'rejected':
              data.push({ key: locale.props.key, action: 'reject' });
              break;
            case 'validated':
              data.push({ key: locale.props.key, action: 'validate' });
              break;
            case 'pending':
              data.push({ key: locale.props.key, action: 'update', state: 'pending' });
              break;
          }
        }
      }
    });

    if (!data.length) {
      return false;
    }

    return api.request('PATCH', data, '/locales/' + locale + '/strings', {})
      .then(function (response) {
        const serverData = response.data.data;

        let updatedStrings = strings;

        serverData.actions.success.forEach(function (action) {
          updatedStrings.forEach(function (original, index) {
            if (action.key === original.props.key) {
              switch (action.action) {
                case 'translate': {
                  if (!updatedStrings[index].props.created_at) {
                    updatedStrings[index].props.created_at = new Date().toISOString().replace('T', ' ').replace(/\..*$/, '');
                  }
                  break;
                }
                case 'update': {
                  updatedStrings[index].props.state = action.state;
                  break;
                }
                case 'delete': {
                  if (updatedStrings[index].props.created_at) {
                    updatedStrings[index].props.created_at = null;
                  }
                  break;
                }
              }
            }
          })
        });
  
        return updatedStrings;
      });
  }

  return this;
}

export default LocaleStringsService;


// WEBPACK FOOTER //
// ./src/Services/LocaleStringsService.js